/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_Leveling_DesignInputs */



/**
* | output |
* | --- |
* | "Level-up messages and cards you design" |
*
* @param {Pricing_Compare_Leveling_DesignInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_leveling_design = /** @type {((inputs?: Pricing_Compare_Leveling_DesignInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_Leveling_DesignInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сообщения о повышении уровня и карточки в вашем оформлении")
	return /** @type {LocalizedString} */ ("Level-up messages and cards you design")
});